export default {
  label: 'Filter Replacement Calculator',
  name: 'filterReplacementCalculator',
  component: 'group',
  description: 'Settings for the filter replacement calculator modal.',
  fields: [
    {
      label: 'CTA to open calculator',
      name: 'ctaToOpenCalculator',
      component: 'text',
      defaultValue: 'Help Me Decide',
    },
    {
      label: 'Calculator Title',
      name: 'title',
      component: 'text',
      defaultValue: 'How often should I change my water filter?',
    },
    {
      label: 'Slider label',
      name: 'label',
      component: 'text',
      defaultValue:
        'Use the slider to select the number of people in your household',
    },
    {
      label: 'CTA within calculator',
      name: 'ctaWithinCalculator',
      component: 'text',
      defaultValue: 'Add To Cart',
    },
    {
      component: 'group-list',
      name: 'recommendations',
      label: 'Products',
      description: 'Recommended purchase frequency by people in household',
      itemProps: {
        label: '{{item.product.handle}}',
      },
      fields: [
        {
          component: 'productSearch',
          name: 'product',
          label: 'Product',
        },
        {
          component: 'group-list',
          name: 'recommendation',
          label: 'Recommendation',
          itemProps: {
            label: '{{item.people}} people -> {{item.frequency}} months',
          },
          fields: [
            {
              component: 'number',
              name: 'people',
              label: 'People',
            },
            {
              component: 'number',
              name: 'frequency',
              label: 'Recommended Purchase Frequency (In Months)',
            },
          ],
        },
      ],
    },
    {
      component: 'markdown',
      name: 'disclaimer',
      label: 'Disclaimer',
    },
  ],
};
